import {NotificationType} from "./notification-type";

export class Notification {
  public isVisible: boolean;

  constructor(
    public message: string,
    public type: NotificationType = NotificationType.INFO,
    public persist: boolean = false,
    public title: string = '',
    public extendHeight = false
  ) {
    this.isVisible = false;
  }

  public add(): void {
    setTimeout(() => {
      this.isVisible = true;
    });
  }

  public remove(): void {
    this.isVisible = false;
  }

}
